//Built-in libraries

//Third party libraries

//Custom components

//Services

//STP Libraries

//Assets and Miscellaneous

//Component Begin

interface IDevelopmentTeamDetailsProps {
  developmentTeam: { role: string; companyName: string }[];
}
export default function DevelopmentTeam({ developmentTeam }: IDevelopmentTeamDetailsProps) {
  return (
    <section aria-labelledby='applicant-information-title'>
      <div className='bg-white shadow sm:rounded-lg'>
        <div className='py-5'>
          <div className='px-4 py-2 sm:px-6 border-l-4 border-primaryColor-normal'>
            <h2 id='applicant-information-title' className='m-0 text-lg leading-6 font-medium text-primaryColor-normal'>
              Development Team
            </h2>
            <p className='mt-1 max-w-2xl text-sm text-gray-500'>Development team members and role</p>
          </div>
        </div>
        <div className='border-t border-gray-200 px-4 py-5 sm:px-6'>
          <dl className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 mb-5'>
            {developmentTeam.length > 0
              ? developmentTeam?.map((dt: { role: string; companyName: string }, index: number) => (
                  <div key={index} className='sm:col-span-2 grid grid-cols-6'>
                    <dt className='col-span-3 text-neutralColor-normal'>{dt.role}</dt>
                    <dd className='col-span-3'>{dt.companyName}</dd>
                  </div>
                ))
              : 'None'}
          </dl>
        </div>
      </div>
    </section>
  );
}
